<script>
export default {
  computed: {
    locale() {
      return this.$i18n.locale.toUpperCase();
    }
  }
};
</script>

<script setup>
import { defineProps, computed } from 'vue';
import { useMutations, useState } from 'vuex-composition-helpers';
import { getCurrencySymbol, widgetViews } from '@/utils';

const props = defineProps({
  delayModal: {
    type: Boolean,
    default: false
  },
  staticForm: {
    type: Boolean,
    default: false
  },
  theme: {
    type: String,
    default: 'dark'
  }
});

const { widgetView } = useState(['widgetView']);
const { currency } = useState('donation', ['currency']);

const { SET_SHOW_LOCALIZATION_MODAL } = useMutations(['SET_SHOW_LOCALIZATION_MODAL']);

const handleClick = () => {
  if (props.delayModal) {
    setTimeout(() => {
      SET_SHOW_LOCALIZATION_MODAL(true);
    }, 500);
  } else {
    SET_SHOW_LOCALIZATION_MODAL(true);
  }
};

const showLocalizationButton = computed(() => {
  if (props.staticForm) {
    return true;
  }

  return [widgetViews.DONATION_FORM.name, widgetViews.DONOR_WALL.name].includes(widgetView.value.name);
});
const flagComputed = computed(() => {
  const flags = {
    usd: 'flag-us',
    eur: 'flag-eu',
    gbp: 'flag-gb',
    aud: 'flag-au',
    cad: 'flag-ca',
    ils: 'flag-il'
  };

  return flags[currency.value.toLowerCase()] || 'flag-us';
});
</script>

<template>
  <div class="flex items-center cursor-pointer">
    <!-- !TODO: need outline-icon-->

    <button
      v-if="showLocalizationButton"
      @click="handleClick"
      title="Localization settings"
      class="localization-button p-1 flex items-center gap-2 rounded transition-ease-out"
      :class="[theme, { 'text-primary-text': theme === 'dark', 'text-black-01': theme === 'light' }]"
    >
      <!-- <app-icon name="globe" type="svg" width="18" height="18" class="text-white fill-current" /> -->
      <span
        :class="{
          'bg-white': theme === 'dark',
          'bg-gray-disabled': theme === 'light'
        }"
        class="p-px rounded-full p-px"
      >
        <app-icon type="svg" :name="flagComputed" height="14" class="text-white fill-current" />
      </span>

      <span class="flex items-center gap-1 text-xs font-nunito-sans font-semibold">
        <span class="font-nunito">{{ currency.toUpperCase() }} ({{ getCurrencySymbol(currency) }})</span>
        <span>•</span>
        <span>{{ locale }}</span>
      </span>
    </button>
  </div>
</template>
